// let prod = "https://com-sparkle-sparkle.herokuapp.com/api"
// let dev = "https://com-sparkle-stage.herokuapp.com/api"
// let local = "http://localhost:8001/api"


let API = `${process.env.REACT_APP_API_URL}/api`


export { API }
